import styled from 'styled-components';
import pageBg from '/images/page-bg-06.png';
import mainPg from '/images/main-bg.png';

export const PageContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: auto; /* Let content determine height */
  z-index: 0;
  padding-bottom: 2rem;

  &::before {
    content: '';
    background-image: url(${pageBg});
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 90vw;
    height: 100%;
    pointer-events: none;
    z-index: -1;
  }

  &::after {
    content: '';
    background-image: url(${mainPg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: -2;
  }

  h1 {
    font-size: 2.5rem;
    color: var(--color-primary); /* Centralized primary color */
    text-align: center;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1rem;
    line-height: 1.8;
    color: var(--color-text); /* Centralized text color */
    text-align: center;
    margin-bottom: 1rem;
  }

  a {
    font-weight: bold;
    color: var(--color-secondary); /* Centralized secondary color */
    transition: color 0.3s;

    &:hover {
      text-decoration: underline;
      color: var(--color-highlight); /* Centralized highlight color */
    }
  }

  @media (max-width: 1198px) {
    padding: 2rem 1rem;
    width: 100%;

    &::before {
      width: 100%; /* Full width for smaller screens */
      background-size: cover;
    }

    &::after {
      width: 100%;
      background-size: cover;
    }
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }

    p {
      font-size: 0.9rem;
    }
  }
`;
